import { useMemo } from 'react'
import useSlabIconFromCenter from './useSlabIconFromCenter'

interface Arguments {
  slab: ShapeObject
  offset?: number
  offsetX?: number
}

const useLiveLoadMetadata = ({ slab, offset = 0.05, offsetX = 0.3 }: Arguments) => {
  const { pointForIcon, rotation } = useSlabIconFromCenter(slab, {
    offsetZ: offset,
    iconSizeX: 0.15,
    iconSizeY: 0.15,
    offsetX,
  })

  return useMemo(() => {
    return {
      liveLoadDisabled: !slab.metadata?.use_global_live_loads,
      pointForIcon,
      rotation,
    }
  }, [pointForIcon, rotation, slab.metadata?.use_global_live_loads])
}

export default useLiveLoadMetadata
